import React from "react";
import Content from "../components/pages/Content/content";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const ContentLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{ margin: "70px 0px 0px 200px", width: "100%" }}>
          <Content />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default ContentLayout;
